module.exports = __webpack_public_path__ + "static/fonts/Roboto-Black.d6a6f88.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/Roboto-Black.ttf
// module id = 8yiX
// module chunks = 0